import React from 'react'
import {NavLink} from 'react-router-dom'
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSignInAlt,
  faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
library.add(
  faSignInAlt,
  faUserPlus
);


const SignedOutLinks = () => {
    return (
        <ul className="right tright">
            <li><NavLink to='/signup'>Signup  <FontAwesomeIcon icon="user-plus" /></NavLink></li>
            <li><NavLink to='/signin'>Login <FontAwesomeIcon icon="sign-in-alt" /></NavLink></li>
        </ul>
    )
}

export default SignedOutLinks